import { action, computed } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';

import { ChannelConnManager } from 'apps/channel/main/connManager';

export default class CommunityTopicsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      channelsCursor: () => null,
      channelsCount: () => this.channelsConn.variables.batchSize,
      channelsSortBy: () => this.channelsConn.sortBy,
    });
    this.channelsConn = new ChannelConnManager(this, {
      initialBatchSize: 40,
      batchSize: 40,
      sortBy: 'top',
      sortOptions: [
        ['top', i18next.t('Top')],
        ['-name', i18next.t('Name')],
        ['recent', i18next.t('Recent')],
      ],
    });
    this.TopicsQuery();
  }

  @computed get loading() {
    return this.channelsConn.loadingMore;
  }

  @action TopicsQuery = () => {
    this.channelsConn.loadMore();
  };
}
